import ReportNg from '@/models/ReportNg/ReportNg';

export default class ReportNgFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterControlCardNumber = '';
		this.filterPartNumber = '';
		this.filterMachine = '';
		this.filterSubprocess = '';
		this.filterCustomer = '';
		this.filterLine = '';
		this.filterPartClassification = '';
		this.filterPeriodDateFrom = '';
		this.filterPeriodDateTo = '';
		this.tempId = '';
		this.createdDateFrom = '';
		this.createdDateTo = '';
		this.partName = '';
		this.partNumber = '';
		this.controlCardNumber = '';
		this.customerName = '';
		this.partSpecification = '';
		this.shift = '';
		this.lineProduction = '';
		this.machineName = '';
		this.subprocess = '';
		this.partClassification = '';
		this.qtyCase = '';
		this.code = '';
		this.name = '';
		this.areaName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterControlCardNumber : '0',
			filterPartNumber : '0',
			filterMachine : '0',
			filterSubprocess : '0',
			filterCustomer : '0',
			filterLine : '0',
			filterPartClassification : '0',
			filterPeriodDateFrom : '0',
			filterPeriodDateTo : '0',
			tempId : '0',
			createdDateFrom : '0',
			createdDateTo : '0',
			partName : '0',
			partNumber : '0',
			controlCardNumber : '0',
			customerName : '0',
			partSpecification : '0',
			shift : '0',
			lineProduction : '0',
			machineName : '0',
			subprocess : '0',
			partClassification : '0',
			qtyCase : '0',
			code : '0',
			name : '0',
			areaName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}